import ProjectCardData from "./projList";
import { useState } from "react";
import Iframe from 'react-iframe';

const Pro1 = () => {
    const [openPopupIndex, setOpenPopupIndex] = useState(-1);

    const openPopup = (index) => {
      setOpenPopupIndex(index);
    };
  
    const closePopup = () => {
      setOpenPopupIndex(-1);
    };
  return (
    <>
      {ProjectCardData.map((e, index) => {
        const isPopupOpen = openPopupIndex === index;

        return (
          <>
            <div className="project_card" data-aos={e.effct}>
              <div>
                <div className="project_container">
                  <div className="project_content">
                    <div>
                      <h3 className="project_head">{e.title}</h3>
                      <div className="line"></div>
                      <ul className="tags">
                        <li>
                          <span className={`tag tag1 ${e.tag1}`}>{e.tag1}</span>
                        </li>
                        <li>
                          <span className={`tag tag2 ${e.tag2}`}>{e.tag2}</span>
                        </li>
                        <li>
                          <span className={`tag tag3 ${e.tag3}`}>{e.tag3}</span>
                        </li>
                        <li>
                          <span className={`tag tag4 ${e.tag4}`}>{e.tag4}</span>
                        </li>
                        <li>
                          <span className={`tag tag5 ${e.tag5}`}>{e.tag5}</span>
                        </li>
                        <a href={e.code} target="_blank" rel="noreferrer">
                          <li>
                            <span className="tag tag6">Code</span>
                          </li>
                        </a>
                      </ul>
                      <p className="small">{e.text}</p>
                    </div>
                  </div>
                  {/* <a onClick={() => openPopup(index)} className="project_img"> */}
                  <a href={e.source} target="__blank" className="project_img">
                    <div>
                      <img
                        className="project_img"
                        src={`../Images/${e.imgsrc}`}
                        alt="syntaxmeet"
                      />
                    </div>
                  </a>
                </div>
              </div>
              {/* <a className="go-corner" onClick={() => openPopup(index)}> */}
              <a className="go-corner" href={e.source} target="__blank">
                <div className="go-arrow">→</div>
              </a>
            </div>
            {isPopupOpen && (
              <div className="popup-overlay" onClick={() => closePopup(index)}>
                <div className="popup-content">
                  <Iframe
                    url={e.source}
                    width="100%"
                    height="100%"
                    id=""
                    className=""
                    display="block"
                    allowFullScreen
                    position="relative"
                  />
                </div>
              </div>
            )}
          </>
        );
      })}
    </>
  );
};

export default Pro1;
